import React, { ReactNode, useEffect, useMemo, useState } from 'react'
import styles from './styles.module.scss'
import {
  Menu,
  Layout,
  Dropdown,
  Badge,
  notification,
  Button,
  Modal,
  Popover,
} from 'antd'
import { useRouteMatch, Route, Switch } from 'react-router-dom'
import { KeepAlive } from 'react-activation'
import { history } from '../../redux/store'
import {
  CaretDownOutlined,
  UserOutlined,
  PoweroffOutlined,
  CarryOutOutlined,
  BellOutlined,
  MailOutlined,
  HomeOutlined,
  FileTextOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  NotificationOutlined,
  ProfileOutlined,
} from '@ant-design/icons'
import {
  GetLocalStorage,
  DelLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { useTypedSelector } from '../../redux/store'
import Customtabs from '../../components/Tabs'
import { MainMenuKey, userRouter } from '../../route'
import { useDispatch } from 'react-redux'
import CustomIcon from '../../components/IconUser'
import socketconnect, { socketdisconnect } from '../../tools/sockClient'
import CustomModal from '../../components/ModalUser'
import {
  GET_MESSAGE_SIZE_LIST,
  GET_MESSAGE_DETAIL,
  MessageItem,
} from '../../api/orderManage'
import { getSupplierId } from '../../tools/util'
import { useSetupHook } from './hooks'
import { jumpOrderDetail } from '../../modules/home/messagebox/hooks'
import IframeModal from '../../components/IframeModal'

interface CustomMenuItem {
  icon?: ReactNode
  label: string
  key: React.Key
  items?: CustomMenuItem[]
  url?: string
  [key: string]: any
}

// 基础布局
const Basiclayout = () => {
  const { updateNotice, openUpdateNotice, closeUpdateNotice } = useSetupHook()
  const match = useRouteMatch()
  const dispatch = useDispatch()
  const { empCode } = useTypedSelector((state) => state.authtoken)
  const { routerObj } = useTypedSelector((state) => state.homeData)
  const { routerList } = useTypedSelector((state) => state.routerModules)
  const supRoute = userRouter[1].url
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [record, setRecord] = useState({
    supplierOrderId: '',
    content: '',
    type: '',
  })
  const [dateSource, setDateSource] = useState<any[]>([])
  const [dotShow, setDotShow] = useState(false)
  const { tabsActive } = useTypedSelector((state) => state.authtoken)
  const getMenuChildren = (cnKey: MainMenuKey) => {
    return routerObj?.[cnKey]?.map((item) => {
      return {
        label: item.title,
        key: item.url,
        url: item.url,
      }
    })
  }

  const fixedMenu = [
    {
      icon: <HomeOutlined />,
      label: '工作台',
      key: '工作台',
      url: '/home',
    },
    {
      icon: <NotificationOutlined />,
      label: '咸亨公告',
      key: '咸亨公告',
      url: '/xhNotice',
    },
  ]
  const withPermissonMenu: CustomMenuItem[] = [
    {
      icon: <UserOutlined />,
      label: '基本信息',
      key: '基本信息',
      items: getMenuChildren('基本信息'),
    },
    {
      icon: <ProfileOutlined />,
      label: '询报价',
      key: '询报价',
      items: getMenuChildren('询报价'),
    },
    {
      icon: <MailOutlined />,
      label: '物料管理',
      key: '物料管理',
      items: getMenuChildren('物料管理'),
    },
    {
      icon: <FileTextOutlined />,
      label: '订单管理',
      key: '订单管理',
      items: getMenuChildren('订单管理'),
    },
    {
      icon: <UserOutlined />,
      label: '客户开票',
      key: '客户开票',
      items: getMenuChildren('客户开票'),
    },
    {
      icon: <MoneyCollectOutlined />,
      label: '开票付款',
      key: '开票付款',
      items: getMenuChildren('开票付款'),
    },
    {
      icon: <SettingOutlined />,
      label: '系统管理',
      key: '系统管理',
      items: getMenuChildren('系统管理'),
    },
  ]
  const menuListMemo = useMemo(() => {
    return [
      ...fixedMenu,
      ...withPermissonMenu.filter((item) => {
        return item.items && Array.isArray(item.items) && item.items.length > 0
      }),
    ]
  }, [fixedMenu, withPermissonMenu])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      startClient()
    }
    getMesList()
    // eslint-disable-next-line
  }, [])
  // 路由切换销毁所有弹窗
  history.listen(() => {
    // 只能销毁 method
    Modal.destroyAll()
  })
  // 开始监听消息推送
  function startClient() {
    socketconnect(
      (msg) => {
        const resData: any = JSON.parse(msg.body)
        console.group('resData')
        console.groupEnd()
        onshowNotic(resData)
      },
      (error) => {
        console.log('Basiclayout -> error', error)
      },
    )
  }

  function onshowNotic(params: {
    executeStateCode: string
    taskType: string
    executeResult: string
    taskId: string
  }) {
    // 随机key
    const key = Math.random().toString(36).substr(2)
    notification.open({
      message: '任务',
      key: key,
      description: (
        <div className="notificationContent">
          <CustomIcon
            type={`${
              params.executeStateCode === '1'
                ? 'icon-chenggong'
                : 'icon-ShapeCopy'
            }`}
            className="icon"
          />
          <div className="contenttext" style={{ whiteSpace: 'pre-line' }}>
            {params.taskType}
            <br />
            {/* eslint-disable-next-line */}
            {params.executeResult.replace(/\<br\/>/g, '\n')}
          </div>
        </div>
      ),
      duration: 0, // 不自动关闭
      placement: 'topRight',
      top: 105,
      className: 'notificationBox',
      btn: (
        <Button
          type="link"
          style={{ padding: '0' }}
          onClick={() => onClickTask(params.taskId, key)}
          prefixCls="xh-btn"
        >
          查看
        </Button>
      ),
    })
  }

  // 点击查看任务
  function onClickTask(id: string, key: string) {
    // 关闭弹窗
    notification.close(key)
    history.replace({
      pathname: `${supRoute}/taskdetail`,
      state: {
        init: 'init',
        taskId: id,
      },
    })
  }

  // 退出
  function onClickoutlogin() {
    // 销毁链接取消订阅
    socketdisconnect()
    // 删除token
    DelLocalStorage('SRM_TOKEN')
    DelLocalStorage('USERID')
    DelLocalStorage('SUPPLIERID')
    DelLocalStorage('SUPPLIER_ERPCODE')
    DelLocalStorage('SUPPLIER_CODE')
    DelLocalStorage('USER_NAME')
    DelLocalStorage('BASEURL')
    DelLocalStorage('ROLE')
    // 重置所有状态
    dispatch({
      type: 'RESET_REDUX',
    })
    // 销毁所有推送消息
    notification.destroy()
    // 跳转登录页
    history.replace({
      pathname: '/login',
      state: {},
    })
  }

  function handleMenuClick(e: any) {
    let url = ''
    if (e.key === '1') {
      // 基本资料
      url = `${supRoute}/baseinfo`
    } else if (e.key === '2') {
      // 退出账号
      onClickoutlogin()
      return false
    }
    history.replace({
      pathname: url,
      state: {
        init: 'initdata',
      },
    })
  }

  // 任务中心
  function onClicktask() {
    history.replace({
      pathname: `${supRoute}/taskcenter`,
    })
  }

  const getMesList = async () => {
    const data = {
      // userId: getUserId(),
      supplierId: getSupplierId(),
    }
    const res = await GET_MESSAGE_SIZE_LIST({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      setDateSource(res.data)
      if (res.data.length) {
        res.data.forEach((item: any) => {
          if (!item.isRead) {
            setDotShow(true)
          }
        })
      }
    }
  }
  const onConfirmDeleteScheme = () => {
    setConfirmVisible(false)
  }

  // 跳转至详情页
  const jumpDetail = () => {
    jumpOrderDetail({
      type: record?.type ?? '',
      supplierOrderId: record?.supplierOrderId ?? '',
    })
    onConfirmDeleteScheme()
  }

  const modalNode = (
    <div>
      <p style={{ fontSize: '20px', fontWeight: 600 }}>{record.content}</p>
      <span onClick={jumpDetail} className="btn-link">
        {'前往处理>>'}
      </span>
      <div style={{ textAlign: 'center', paddingTop: '10px' }}>
        <Button type="primary" onClick={onConfirmDeleteScheme}>
          确定
        </Button>
      </div>
    </div>
  )
  function onClickMsg() {
    history.replace({
      pathname: `${supRoute}/messageCenter`,
    })
  }

  const items = empCode
    ? [
        {
          label: (
            <span>
              <UserOutlined />
              个人信息
            </span>
          ),
          key: '1',
        },
        {
          label: (
            <span>
              <PoweroffOutlined />
              退出账号
            </span>
          ),
          key: '2',
        },
      ]
    : [
        {
          label: (
            <span>
              <PoweroffOutlined />
              退出账号
            </span>
          ),
          key: '2',
        },
      ]
  const openModal = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      setConfirmVisible(true)
      setRecord({ ...res.data, type: record.type })
    }
  }
  const content = (
    <div>
      {dateSource.map((item: any) => {
        return (
          <div
            key={item?.id}
            style={{ cursor: 'pointer' }}
            onClick={() => openModal(item)}
          >
            {item.isRead ? (
              <p>{item.content}</p>
            ) : (
              <p style={{ color: 'rgb(29, 74, 189)' }}>{item.content}</p>
            )}
            <p style={{ textAlign: 'right' }}>{item.time}</p>
          </div>
        )
      })}
    </div>
  )
  const titleDom = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '320px',
      }}
    >
      <div style={{ fontWeight: 600 }}>消息中心</div>
      <div style={{ fontSize: '14px', cursor: 'pointer' }} onClick={onClickMsg}>
        {'查看全部>'}
      </div>
    </div>
  )
  const generateMenuItem = (menuItem: CustomMenuItem) => {
    // 存在子菜单的情况，返回submenu
    if (menuItem?.items && menuItem.items.length > 0) {
      return (
        <Menu.SubMenu
          icon={menuItem.icon}
          title={menuItem.label}
          key={menuItem.key}
        >
          {menuItem.items.map((item: any) => {
            return generateMenuItem(item)
          })}
        </Menu.SubMenu>
      )
    } else {
      return (
        <Menu.Item
          icon={menuItem?.icon}
          key={menuItem.key}
          onClick={() => {
            if (menuItem?.url) {
              const url = supRoute + menuItem.url
              let BtnState: string[] = []
              if (menuItem.url === '/addgoods') {
                // 新增物料
                BtnState = ['Edit', 'Add']
              }
              history.push({
                pathname: url,
                state: {
                  init: 'initdata',
                  BtnState: BtnState,
                  // 审核来源：新增物料
                  auditSource:
                    menuItem.url === '/addgoods' ? 'SRM_SECOND_ADD' : undefined,
                },
              })
            }
          }}
        >
          {menuItem.label}
        </Menu.Item>
      )
    }
  }

  return (
    <Layout style={{ height: '100%' }}>
      {/* header头部 */}
      <Layout.Header className={styles.header}>
        <div className={styles.logo}>咸亨国际供应商协同平台（SCP）</div>
        <div className={styles.userheader}>
          <span
            className={styles.updateNotice}
            onClick={() => {
              openUpdateNotice()
            }}
          >
            更新通知
          </span>
          {/* 消息中心 */}
          <span className={styles.taskbox}>
            <Badge dot={dotShow}>
              <Popover
                placement="bottomRight"
                content={content}
                title={titleDom}
              >
                <BellOutlined
                  onClick={onClickMsg}
                  style={{ fontSize: '16px', color: 'white' }}
                />
              </Popover>
            </Badge>
          </span>
          {/* 任务中心 */}
          <span className={styles.taskbox} onClick={onClicktask}>
            <Badge dot>
              <CarryOutOutlined style={{ fontSize: '16px', color: 'white' }} />
            </Badge>
          </span>
          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            placement="bottom"
          >
            <span className={styles.text}>
              {GetLocalStorage('USER_NAME')
                ? GetLocalStorage('USER_NAME')
                : '管理员'}
              <CaretDownOutlined />
            </span>
          </Dropdown>
        </div>
      </Layout.Header>
      {/* content */}
      <Layout>
        <Layout.Sider
          className={styles['sider']}
          style={{
            background: 'white',
          }}
          collapsible
          theme="light"
        >
          {/* 侧边栏 */}
          <Menu
            mode="inline"
            defaultOpenKeys={['订单管理', '客户开票', '开票付款']}
            selectedKeys={[tabsActive.slice(4)]}
          >
            {menuListMemo.map((item) => {
              return generateMenuItem(item)
            })}
            {/* <div className="h-[100px] bg-[#FAFAFA]"></div> */}
            <div className="h-[100px] bg-[#fff]"></div>
          </Menu>
        </Layout.Sider>
        <Layout>
          <Layout.Header
            style={{
              height: 'auto',
              padding: '0',
              background: 'white',
              display: 'block',
            }}
          >
            {/* tabs */}
            <Customtabs />
          </Layout.Header>
          <Layout.Content className={styles['main-area']}>
            <Switch>
              {routerList.map((item) => {
                const RouteComp = item.component as any
                return item.cache ? (
                  <Route
                    key={item.key}
                    exact={item.exact}
                    path={match.path + item.url}
                    render={(props) => (
                      <KeepAlive
                        cacheKey={item.key}
                        name={item.key}
                        // saveScrollPosition="screen"
                      >
                        {<RouteComp {...props} />}
                      </KeepAlive>
                    )}
                  />
                ) : (
                  <Route
                    key={item.key}
                    exact={item.exact}
                    path={match.path + item.url}
                    component={RouteComp}
                  />
                )
              })}
            </Switch>
            <CustomModal
              width={470}
              open={confirmVisible}
              title={'消息详情'}
              footer={false}
              modalCancel={onConfirmDeleteScheme}
            >
              {modalNode}
            </CustomModal>
          </Layout.Content>
        </Layout>
      </Layout>
      {/* 更新公告通知 */}
      <IframeModal
        open={updateNotice}
        closeModal={closeUpdateNotice}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzqkAvpVNWVmYE"
      />
    </Layout>
  )
}

export default Basiclayout
import React, { ReactNode, useEffect, useMemo, useState } from 'react'
import styles from './styles.module.scss'
import {
  Menu,
  Layout,
  Dropdown,
  Badge,
  notification,
  Button,
  Modal,
  Popover,
} from 'antd'
import { useRouteMatch, Route, Switch } from 'react-router-dom'
import { KeepAlive } from 'react-activation'
import { history } from '../../redux/store'
import {
  CaretDownOutlined,
  UserOutlined,
  PoweroffOutlined,
  CarryOutOutlined,
  BellOutlined,
  MailOutlined,
  HomeOutlined,
  FileTextOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  NotificationOutlined,
  ProfileOutlined,
} from '@ant-design/icons'
import {
  GetLocalStorage,
  DelLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { useTypedSelector } from '../../redux/store'
import Customtabs from '../../components/Tabs'
import { MainMenuKey, userRouter } from '../../route'
import { useDispatch } from 'react-redux'
import CustomIcon from '../../components/IconUser'
import socketconnect, { socketdisconnect } from '../../tools/sockClient'
import CustomModal from '../../components/ModalUser'
import {
  GET_MESSAGE_SIZE_LIST,
  GET_MESSAGE_DETAIL,
  MessageItem,
} from '../../api/orderManage'
import { getSupplierId } from '../../tools/util'
import { useSetupHook } from './hooks'
import { jumpOrderDetail } from '../../modules/home/messagebox/hooks'
import IframeModal from '../../components/IframeModal'

interface CustomMenuItem {
  icon?: ReactNode
  label: string
  key: React.Key
  items?: CustomMenuItem[]
  url?: string
  [key: string]: any
}

// 基础布局
const Basiclayout = () => {
  const { updateNotice, openUpdateNotice, closeUpdateNotice } = useSetupHook()
  const match = useRouteMatch()
  const dispatch = useDispatch()
  const { empCode } = useTypedSelector((state) => state.authtoken)
  const { routerObj } = useTypedSelector((state) => state.homeData)
  const { routerList } = useTypedSelector((state) => state.routerModules)
  const supRoute = userRouter[1].url
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [record, setRecord] = useState({
    supplierOrderId: '',
    content: '',
    type: '',
  })
  const [dateSource, setDateSource] = useState<any[]>([])
  const [dotShow, setDotShow] = useState(false)
  const { tabsActive } = useTypedSelector((state) => state.authtoken)
  const getMenuChildren = (cnKey: MainMenuKey) => {
    return routerObj?.[cnKey]?.map((item) => {
      return {
        label: item.title,
        key: item.url,
        url: item.url,
      }
    })
  }

  const fixedMenu = [
    {
      icon: <HomeOutlined />,
      label: '工作台',
      key: '工作台',
      url: '/home',
    },
    {
      icon: <NotificationOutlined />,
      label: '咸亨公告',
      key: '咸亨公告',
      url: '/xhNotice',
    },
  ]
  const withPermissonMenu: CustomMenuItem[] = [
    {
      icon: <UserOutlined />,
      label: '基本信息',
      key: '基本信息',
      items: getMenuChildren('基本信息'),
    },
    {
      icon: <ProfileOutlined />,
      label: '询报价',
      key: '询报价',
      items: getMenuChildren('询报价'),
    },
    {
      icon: <MailOutlined />,
      label: '物料管理',
      key: '物料管理',
      items: getMenuChildren('物料管理'),
    },
    {
      icon: <FileTextOutlined />,
      label: '订单管理',
      key: '订单管理',
      items: getMenuChildren('订单管理'),
    },
    {
      icon: <UserOutlined />,
      label: '客户开票',
      key: '客户开票',
      items: getMenuChildren('客户开票'),
    },
    {
      icon: <MoneyCollectOutlined />,
      label: '开票付款',
      key: '开票付款',
      items: getMenuChildren('开票付款'),
    },
    {
      icon: <SettingOutlined />,
      label: '系统管理',
      key: '系统管理',
      items: getMenuChildren('系统管理'),
    },
  ]
  const menuListMemo = useMemo(() => {
    return [
      ...fixedMenu,
      ...withPermissonMenu.filter((item) => {
        return item.items && Array.isArray(item.items) && item.items.length > 0
      }),
    ]
  }, [fixedMenu, withPermissonMenu])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      startClient()
    }
    getMesList()
    // eslint-disable-next-line
  }, [])
  // 路由切换销毁所有弹窗
  history.listen(() => {
    // 只能销毁 method
    Modal.destroyAll()
  })
  // 开始监听消息推送
  function startClient() {
    socketconnect(
      (msg) => {
        const resData: any = JSON.parse(msg.body)
        console.group('resData')
        console.groupEnd()
        onshowNotic(resData)
      },
      (error) => {
        console.log('Basiclayout -> error', error)
      },
    )
  }

  function onshowNotic(params: {
    executeStateCode: string
    taskType: string
    executeResult: string
    taskId: string
  }) {
    // 随机key
    const key = Math.random().toString(36).substr(2)
    notification.open({
      message: '任务',
      key: key,
      description: (
        <div className="notificationContent">
          <CustomIcon
            type={`${
              params.executeStateCode === '1'
                ? 'icon-chenggong'
                : 'icon-ShapeCopy'
            }`}
            className="icon"
          />
          <div className="contenttext" style={{ whiteSpace: 'pre-line' }}>
            {params.taskType}
            <br />
            {/* eslint-disable-next-line */}
            {params.executeResult.replace(/\<br\/>/g, '\n')}
          </div>
        </div>
      ),
      duration: 0, // 不自动关闭
      placement: 'topRight',
      top: 105,
      className: 'notificationBox',
      btn: (
        <Button
          type="link"
          style={{ padding: '0' }}
          onClick={() => onClickTask(params.taskId, key)}
          prefixCls="xh-btn"
        >
          查看
        </Button>
      ),
    })
  }

  // 点击查看任务
  function onClickTask(id: string, key: string) {
    // 关闭弹窗
    notification.close(key)
    history.replace({
      pathname: `${supRoute}/taskdetail`,
      state: {
        init: 'init',
        taskId: id,
      },
    })
  }

  // 退出
  function onClickoutlogin() {
    // 销毁链接取消订阅
    socketdisconnect()
    // 删除token
    DelLocalStorage('SRM_TOKEN')
    DelLocalStorage('USERID')
    DelLocalStorage('SUPPLIERID')
    DelLocalStorage('SUPPLIER_ERPCODE')
    DelLocalStorage('SUPPLIER_CODE')
    DelLocalStorage('USER_NAME')
    DelLocalStorage('BASEURL')
    DelLocalStorage('ROLE')
    // 重置所有状态
    dispatch({
      type: 'RESET_REDUX',
    })
    // 销毁所有推送消息
    notification.destroy()
    // 跳转登录页
    history.replace({
      pathname: '/login',
      state: {},
    })
  }

  function handleMenuClick(e: any) {
    let url = ''
    if (e.key === '1') {
      // 基本资料
      url = `${supRoute}/baseinfo`
    } else if (e.key === '2') {
      // 退出账号
      onClickoutlogin()
      return false
    }
    history.replace({
      pathname: url,
      state: {
        init: 'initdata',
      },
    })
  }

  // 任务中心
  function onClicktask() {
    history.replace({
      pathname: `${supRoute}/taskcenter`,
    })
  }

  const getMesList = async () => {
    const data = {
      // userId: getUserId(),
      supplierId: getSupplierId(),
    }
    const res = await GET_MESSAGE_SIZE_LIST({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      setDateSource(res.data)
      if (res.data.length) {
        res.data.forEach((item: any) => {
          if (!item.isRead) {
            setDotShow(true)
          }
        })
      }
    }
  }
  const onConfirmDeleteScheme = () => {
    setConfirmVisible(false)
  }

  // 跳转至详情页
  const jumpDetail = () => {
    jumpOrderDetail({
      type: record?.type ?? '',
      supplierOrderId: record?.supplierOrderId ?? '',
    })
    onConfirmDeleteScheme()
  }

  const modalNode = (
    <div>
      <p style={{ fontSize: '20px', fontWeight: 600 }}>{record.content}</p>
      <span onClick={jumpDetail} className="btn-link">
        {'前往处理>>'}
      </span>
      <div style={{ textAlign: 'center', paddingTop: '10px' }}>
        <Button type="primary" onClick={onConfirmDeleteScheme}>
          确定
        </Button>
      </div>
    </div>
  )
  function onClickMsg() {
    history.replace({
      pathname: `${supRoute}/messageCenter`,
    })
  }

  const items = empCode
    ? [
        {
          label: (
            <span>
              <UserOutlined />
              个人信息
            </span>
          ),
          key: '1',
        },
        {
          label: (
            <span>
              <PoweroffOutlined />
              退出账号
            </span>
          ),
          key: '2',
        },
      ]
    : [
        {
          label: (
            <span>
              <PoweroffOutlined />
              退出账号
            </span>
          ),
          key: '2',
        },
      ]
  const openModal = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      setConfirmVisible(true)
      setRecord({ ...res.data, type: record.type })
    }
  }
  const content = (
    <div>
      {dateSource.map((item: any) => {
        return (
          <div
            key={item?.id}
            style={{ cursor: 'pointer' }}
            onClick={() => openModal(item)}
          >
            {item.isRead ? (
              <p>{item.content}</p>
            ) : (
              <p style={{ color: 'rgb(29, 74, 189)' }}>{item.content}</p>
            )}
            <p style={{ textAlign: 'right' }}>{item.time}</p>
          </div>
        )
      })}
    </div>
  )
  const titleDom = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '320px',
      }}
    >
      <div style={{ fontWeight: 600 }}>消息中心</div>
      <div style={{ fontSize: '14px', cursor: 'pointer' }} onClick={onClickMsg}>
        {'查看全部>'}
      </div>
    </div>
  )
  const generateMenuItem = (menuItem: CustomMenuItem) => {
    // 存在子菜单的情况，返回submenu
    if (menuItem?.items && menuItem.items.length > 0) {
      return (
        <Menu.SubMenu
          icon={menuItem.icon}
          title={menuItem.label}
          key={menuItem.key}
        >
          {menuItem.items.map((item: any) => {
            return generateMenuItem(item)
          })}
        </Menu.SubMenu>
      )
    } else {
      return (
        <Menu.Item
          icon={menuItem?.icon}
          key={menuItem.key}
          onClick={() => {
            if (menuItem?.url) {
              const url = supRoute + menuItem.url
              let BtnState: string[] = []
              if (menuItem.url === '/addgoods') {
                // 新增物料
                BtnState = ['Edit', 'Add']
              }
              history.push({
                pathname: url,
                state: {
                  init: 'initdata',
                  BtnState: BtnState,
                  // 审核来源：新增物料
                  auditSource:
                    menuItem.url === '/addgoods' ? 'SRM_SECOND_ADD' : undefined,
                },
              })
            }
          }}
        >
          {menuItem.label}
        </Menu.Item>
      )
    }
  }

  return (
    <Layout style={{ height: '100%' }}>
      {/* header头部 */}
      <Layout.Header className={styles.header}>
        <div className={styles.logo}>咸亨国际供应商协同平台（SCP）</div>
        <div className={styles.userheader}>
          <span
            className={styles.updateNotice}
            onClick={() => {
              openUpdateNotice()
            }}
          >
            更新通知
          </span>
          {/* 消息中心 */}
          <span className={styles.taskbox}>
            <Badge dot={dotShow}>
              <Popover
                placement="bottomRight"
                content={content}
                title={titleDom}
              >
                <BellOutlined
                  onClick={onClickMsg}
                  style={{ fontSize: '16px', color: 'white' }}
                />
              </Popover>
            </Badge>
          </span>
          {/* 任务中心 */}
          <span className={styles.taskbox} onClick={onClicktask}>
            <Badge dot>
              <CarryOutOutlined style={{ fontSize: '16px', color: 'white' }} />
            </Badge>
          </span>
          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            placement="bottom"
          >
            <span className={styles.text}>
              {GetLocalStorage('USER_NAME')
                ? GetLocalStorage('USER_NAME')
                : '管理员'}
              <CaretDownOutlined />
            </span>
          </Dropdown>
        </div>
      </Layout.Header>
      {/* content */}
      <Layout>
        <Layout.Sider
          className={styles['sider']}
          style={{
            background: 'white',
          }}
          collapsible
          theme="light"
        >
          {/* 侧边栏 */}
          <Menu
            mode="inline"
            defaultOpenKeys={['订单管理', '客户开票', '开票付款']}
            selectedKeys={[tabsActive.slice(4)]}
          >
            {menuListMemo.map((item) => {
              return generateMenuItem(item)
            })}
            {/* <div className="h-[100px] bg-[#FAFAFA]"></div> */}
            <div className="h-[100px] bg-[#fff]"></div>
          </Menu>
        </Layout.Sider>
        <Layout>
          <Layout.Header
            style={{
              height: 'auto',
              padding: '0',
              background: 'white',
              display: 'block',
            }}
          >
            {/* tabs */}
            <Customtabs />
          </Layout.Header>
          <Layout.Content className={styles['main-area']}>
            <Switch>
              {routerList.map((item) => {
                const RouteComp = item.component as any
                return item.cache ? (
                  <Route
                    key={item.key}
                    exact={item.exact}
                    path={match.path + item.url}
                    render={(props) => (
                      <KeepAlive
                        cacheKey={item.key}
                        name={item.key}
                        // saveScrollPosition="screen"
                      >
                        {<RouteComp {...props} />}
                      </KeepAlive>
                    )}
                  />
                ) : (
                  <Route
                    key={item.key}
                    exact={item.exact}
                    path={match.path + item.url}
                    component={RouteComp}
                  />
                )
              })}
            </Switch>
            <CustomModal
              width={470}
              open={confirmVisible}
              title={'消息详情'}
              footer={false}
              modalCancel={onConfirmDeleteScheme}
            >
              {modalNode}
            </CustomModal>
          </Layout.Content>
        </Layout>
      </Layout>
      {/* 更新公告通知 */}
      <IframeModal
        open={updateNotice}
        closeModal={closeUpdateNotice}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzqkAvpVNWVmYE"
      />
    </Layout>
  )
}

export default Basiclayout
